export const NOTIFICATIONS_PAGE_SIZE = 10;

export interface NotificationAction {
  label: string;
  url: string;
}

export interface NotificationItem {
  id: string;
  title: string;
  body: string;
  createdAt: string;
  isRead: boolean;
  action?: NotificationAction;
}

export interface NotificationList {
  items: NotificationItem[];
  total?: number;
}

export interface UnreadNotificationsCount {
  count: number;
}

export interface GetNotificationsParams {
  limit?: number;
  offset?: number;
}
